import { H1, H3, H2, Text } from '../ui/typography';
import { Link } from 'react-router-dom';
import PageSeo from '../seo/PageSeo';

function Fields() {
  return (
    <>
      <PageSeo
        title="Tesnoba, izgorelost, travma | Področja dela"
        description="Psihoterapija za anksioznost, izgorelost, travmo in težave v odnosih v Ljubljani. Področja dela Špele Verbnik."
        path="/fields"
      />
      <div className='bg-primaryBg'>
        <div className="lg:w-1/2 m-auto flex flex-col items-center align-middle pt-12 pl-4 pr-4">
          <H1 style={{color: "#616287"}}>Področja dela</H1>
          <H2 className="text-center">skupaj skozi ovinke življenja</H2>

          <Text className="text-base text-left pt-12">Vsaka pot, ki pripelje do razmišljanja o psihoterapiji, je edinstvena. Morda je to akutna stiska, ponavljajoč se vzorec v odnosih ali vztrajen občutek, da življenje ni takšno, kot bi si želeli. Vsak od povodov je pomemben in dragocen začetek.</Text>          
          <Text className="text-base text-left pt-12">Hkrati pa ima vsaka stiska svoje korenine v širšem življenjskem kontekstu in pogosto nosi globlji pomen. Ravno zato psihoterapija presega zgolj osredotočanje na simptome. Je proces, v katerem je pomembna celota: doživljanje, odnosi in življenjska zgodba klienta.</Text>
          <Text className="text-base text-left pt-12">Ne glede na to, ali se name obrnete kot posameznik (odrasel, otrok ali mladostnik), par ali družina, vam spodnji seznam lahko služi kot zemljevid za lažje prepoznavanje in ubeseditev lastne izkušnje. Vendar pa je ta seznam zgolj kažipot. Tudi če vaša stiska na njem nima imena ali ga še iščete, je v terapevtskem prostoru dobrodošla.</Text>
          <Text className="text-base text-left pt-12">To je prostor, kjer vsakdo najde zavetje, vsaka izkušnja pa svoj glas in mesto.</Text>
          <div className='flex justify-center align-middle pt-12  w-full'>
            <img className='w-1/3 md:w-[13%]' src="/assets/logo_filler_sage.svg" alt="" />
          </div>

          <H3 className="pt-12 text-3xl">Doživljanje sebe in notranji svet</H3>
          <div className="pb-12">
            <ul className="list-disc p-6 self-start">
              <li className="text-base pt-2 font-inter"><Text className="text-base">Tesnobna stanja: panični napadi, socialna anksioznost, stalna skrb ali napetost</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Depresivna razpoloženja in občutek nemoči: občutki obupa, praznine, izguba smisla ali brezvoljnost</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Obremenjujoči občutki: globoka krivda, sram ali težko obvladljiva jeza</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Nizka samopodoba: občutki manjvrednosti, samokritičnosti ali negotovosti</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Stres in izgorelost: občutki preobremenjenosti, perfekcionizem, pretirana odgovornost</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Predelava travmatičnih izkušenj in kompleksne travme</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Psihosomatske težave: kronična utrujenost, nespečnost ali ponavljajoči se telesni simptomi brez jasne medicinske razlage</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Motnje hranjenja</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Različne oblike zasvojenosti</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Samopoškodovalno vedenje</Text></li>
            </ul>
            <H3 className="pt-12 text-3xl">Odnosi</H3>
            <ul className="list-disc p-6 self-start">
              <li className="text-base pt-2 font-inter"><Text className="text-base">Partnerski odnos: komunikacija in konflikti, soočanje z nezvestobo in ljubosumjem, predelava preteklih ran, izguba sebe v odnosu, težave v spolnosti ali intimnosti</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">
                Družinski odnosi: vpliv izvorne družine, ponavljajoči se družinski vzorci (medgeneracijski in transgeneracijski prenosi), osvobajanje od nezavedno prevzetih vlog (npr. »rešitelja«, »odgovornega«), konflikti ali odtujenost
</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Povezovanje z drugimi: postavljanje mej, občutki osamljenosti, strah pred bližino ali stiske pri navezovanju stikov (prijateljskih, poklicnih)
</Text></li>
            </ul>

            <H3 className="pt-12 text-3xl">Življenjske prelomnice in iskanje smisla</H3>
            <ul className="list-disc p-6 self-start">
              <li className="text-base pt-2 font-inter"><Text className="text-base">Soočanje s spremembami in izgubami: žalovanje ob smrti bližnjega ali koncu odnosa ter soočanje z drugimi življenjskimi prelomnicami, kot so izguba zaposlitve, selitev ali upokojitev
</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Iskanje identitete: raziskovanje vprašanj o tem, kdo sem, na osebni, spolni ali življenjski ravni
                </Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Eksistencialna vprašanja: iskanje smisla in namena ali strah pred minljivostjo 

                </Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Želja po osebni rasti: poglabljanje stika s seboj, raziskovanje lastnih potencialov ali življenje v večji skladnosti s seboj

                </Text></li>
            </ul>

            <H3 className="pt-12 text-3xl">Za otroke, mladostnike in starše</H3>
            <ul className="list-disc p-6 self-start">
              <li className="text-base pt-2 font-inter"><Text className="text-base">Čustvene in vedenjske stiske: izbruhi jeze, tesnobnost, umik vase ali agresivno vedenje
</Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">
                Podpora pri izzivih nevrorazličnosti (npr. ADHD, motnja avtističnega spektra): razumevanje in izražanje močnih čustev na ustrezen način ali krepitev socialnih veščin in pozitivne samopodobe

                </Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">
                Stiske v šoli in med vrstniki: učne težave, medvrstniško nasilje ali težave pri vključevanju v družbo

                </Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Soočanje s spremembami v družini: ločitev staršev, selitev ali prihod sorojenca

                </Text></li>
              <li className="text-base pt-2 font-inter"><Text className="text-base">Težave s samopodobo in iskanje identitete v obdobju odraščanja
</Text></li>
<li className="text-base pt-2 font-inter"><Text className="text-base">Svetovanje in podpora staršem: krepitev starševskih veščin za razumevanje, način odzivanja na otrokove stiske, postavljanje mej, soočanje z lastno izčrpanostjo, občutki nemoči ali skrb zase v starševski vlogi


</Text></li>
            </ul>

            <div className='flex justify-center align-middle pt-6  w-full'>
              <img className='w-1/3 md:w-[13%]' src="/assets/logo_filler_sage.svg" alt="" />
            </div>

            <Text className="text-base pt-12">Če se ob prebiranju opisov prepoznate ali čutite, da bi vam psihoterapija koristila, vas vabim, da naredite prvi korak in stopite v stik z mano.
            </Text>
            <div className='flex justify-center align-middle pt-12 pb-12 w-full'>
                <button className="bg-secondaryBg text-white px-6 py-2 mt-6 rounded hover:bg-secondaryHover transition-colors">
                <Link to="/contact" className={`text-center w-full font-inter whitespace-nowrap cursor-pointer text-lg`}>Kontakt</Link>
              </button>
            </div>
            
          </div>
        </div>
      </div>
      
    </>
    
  );
}

export default Fields; 